
import React from 'react';
import { Input, Layout, Select, Table } from 'antd';
import { HeaderAspirante } from '../../components/HeaderAspirante';
import useBuscarAspirantes from '../../hooks/adminexamen/useBuscarAspirantes';
import { SearchOutlined } from '@ant-design/icons';

const { Content, Footer } = Layout;

export default function BuscarAspirante() {

    const { columns, resultados, loading, filtrar, ciclosExamen, ciclo, setCiclo } = useBuscarAspirantes()

    return (
        <Layout>
            <HeaderAspirante />
            <Content
                className="site-layout"
                style={{
                    padding: '0 50px',
                    marginTop: 50,
                }}
            >
                <div
                    className="site-layout-background"
                    style={{
                        padding: 24,
                        minHeight: 380,
                    }}
                >
                    <p>Buscar por año:</p>
                    <Select
                        size="large"
                        style={{
                            width: 200,
                            marginBottom: 20
                        }}
                        onChange={ setCiclo }
                        defaultValue={ ciclo }
                    >
                        { ciclosExamen.map((e, i) =>{
                            return (
                                <Select.Option key={ i } value={ e.ciclo_examen }>
                                    { e.ciclo_examen }
                                </Select.Option>
                            )}) }
                    </Select>

                    <Input size='large' placeholder="Buscar por nombre, prematrícula o CURP" allowClear onChange={ filtrar } prefix={ <SearchOutlined /> } style={{
                        marginBottom: 20
                    }}/>

                    <Table dataSource={ resultados } columns={ columns } loading={ loading } rowKey="prematricula"/>
                </div>
            </Content>
            <Footer
                style={{
                    textAlign: 'center',
                }}
            >
                Universidad Tecnológica de Escuinapa ©2022
            </Footer>
        </Layout>
    )
}

